import { deleteTenderSupportDocumentDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteTenderSupportDocumentCallable = getCallable(
  deleteTenderSupportDocumentDefinition,
);
